//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//
//       bebopc version:
//           3.0.6
//
//
//       bebopc source:
//           https://github.com/betwixt-labs/bebop
//
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
import { BebopView, BebopRuntimeError, BebopRecord, BebopJson, BebopTypeGuard, Guid, GuidMap } from "bebop";
import { Metadata, MethodType } from "@tempojs/common";
import {  BaseClient, MethodInfo, CallOptions } from "@tempojs/client";

export const BEBOP_SCHEMA = new Uint8Array([
3, 12, 0, 0, 0, 69, 109, 112, 116, 121, 0, 1, 0, 0, 0, 0,
0, 0, 1, 0, 84, 111, 107, 101, 110, 80, 97, 121, 108, 111,
97, 100, 0, 1, 0, 0, 39, 0, 0, 0, 0, 2, 101, 120, 112, 0,
243, 255, 255, 255, 0, 100, 97, 116, 97, 0, 3, 0, 0, 0, 0,
70, 101, 97, 116, 117, 114, 101, 82, 101, 113, 117, 101,
115, 116, 83, 116, 97, 116, 117, 115, 0, 4, 0, 251, 255,
255, 255, 0, 4, 0, 0, 0, 4, 78, 111, 110, 101, 0, 0, 0, 0,
0, 0, 80, 101, 110, 100, 105, 110, 103, 0, 0, 1, 0, 0, 0,
65, 99, 99, 101, 112, 116, 101, 100, 0, 0, 2, 0, 0, 0, 82,
101, 106, 101, 99, 116, 101, 100, 0, 0, 3, 0, 0, 0, 85,
115, 101, 114, 0, 1, 0, 0, 31, 0, 0, 0, 0, 8, 105, 100, 0,
249, 255, 255, 255, 0, 110, 97, 109, 101, 0, 245, 255,
255, 255, 0, 108, 101, 118, 101, 108, 0, 253, 255, 255,
255, 0, 97, 118, 97, 116, 97, 114, 0, 245, 255, 255, 255,
0, 112, 108, 97, 121, 84, 105, 109, 101, 0, 251, 255, 255,
255, 0, 111, 119, 110, 101, 100, 65, 112, 112, 115, 0,
242, 255, 255, 255, 0, 251, 255, 255, 255, 0, 119, 101,
105, 103, 104, 116, 0, 254, 255, 255, 255, 0, 112, 114,
111, 102, 105, 108, 101, 85, 114, 108, 0, 245, 255, 255,
255, 0, 70, 101, 97, 116, 117, 114, 101, 82, 101, 113,
117, 101, 115, 116, 0, 2, 0, 5, 0, 0, 0, 11, 105, 100, 0,
244, 255, 255, 255, 0, 1, 99, 114, 101, 97, 116, 111, 114,
73, 100, 0, 249, 255, 255, 255, 0, 2, 117, 112, 118, 111,
116, 101, 115, 0, 251, 255, 255, 255, 0, 3, 100, 111, 119,
110, 118, 111, 116, 101, 115, 0, 251, 255, 255, 255, 0, 4,
115, 116, 97, 116, 117, 115, 0, 2, 0, 0, 0, 0, 5, 116,
105, 116, 108, 101, 0, 245, 255, 255, 255, 0, 6, 100, 101,
115, 99, 114, 105, 112, 116, 105, 111, 110, 0, 245, 255,
255, 255, 0, 7, 99, 114, 101, 97, 116, 101, 100, 0, 243,
255, 255, 255, 0, 8, 117, 112, 100, 97, 116, 101, 100, 0,
243, 255, 255, 255, 0, 9, 119, 101, 105, 103, 104, 116, 0,
254, 255, 255, 255, 0, 10, 112, 105, 110, 110, 101, 100,
0, 255, 255, 255, 255, 0, 11, 70, 101, 97, 116, 117, 114,
101, 82, 101, 113, 117, 101, 115, 116, 82, 101, 115, 112,
111, 110, 115, 101, 0, 1, 0, 0, 37, 0, 0, 0, 0, 3, 114,
101, 113, 117, 101, 115, 116, 0, 4, 0, 0, 0, 0, 99, 114,
101, 97, 116, 111, 114, 0, 3, 0, 0, 0, 0, 117, 115, 101,
114, 86, 111, 116, 101, 0, 254, 255, 255, 255, 0, 86, 111,
116, 101, 82, 101, 113, 117, 101, 115, 116, 0, 1, 0, 0,
17, 0, 0, 0, 1, 2, 102, 101, 97, 116, 117, 114, 101, 82,
101, 113, 117, 101, 115, 116, 73, 100, 0, 244, 255, 255,
255, 0, 118, 111, 116, 101, 0, 254, 255, 255, 255, 0, 82,
101, 119, 97, 114, 100, 82, 101, 113, 117, 101, 115, 116,
0, 1, 0, 0, 4, 0, 0, 0, 1, 1, 101, 118, 101, 110, 116, 73,
100, 0, 251, 255, 255, 255, 0, 82, 101, 119, 97, 114, 100,
0, 1, 0, 0, 16, 0, 0, 0, 0, 4, 116, 105, 116, 108, 101, 0,
245, 255, 255, 255, 0, 105, 99, 111, 110, 0, 245, 255,
255, 255, 0, 99, 111, 110, 116, 101, 110, 116, 0, 245,
255, 255, 255, 0, 98, 97, 99, 107, 103, 114, 111, 117,
110, 100, 67, 111, 108, 111, 114, 0, 245, 255, 255, 255,
0, 82, 101, 119, 97, 114, 100, 82, 101, 115, 112, 111,
110, 115, 101, 0, 2, 0, 5, 0, 0, 0, 2, 114, 101, 119, 97,
114, 100, 0, 8, 0, 0, 0, 0, 1, 102, 105, 108, 108, 101,
114, 0, 242, 255, 255, 255, 0, 8, 0, 0, 0, 0, 2, 73, 115,
69, 118, 101, 110, 116, 65, 99, 116, 105, 118, 101, 82,
101, 113, 117, 101, 115, 116, 0, 1, 0, 0, 4, 0, 0, 0, 1,
1, 101, 118, 101, 110, 116, 73, 100, 0, 251, 255, 255,
255, 0, 73, 115, 69, 118, 101, 110, 116, 65, 99, 116, 105,
118, 101, 82, 101, 115, 112, 111, 110, 115, 101, 0, 1, 0,
0, 1, 0, 0, 0, 1, 1, 105, 115, 65, 99, 116, 105, 118, 101,
0, 255, 255, 255, 255, 0, 1, 0, 0, 0, 86, 111, 105, 99,
101, 0, 0, 7, 0, 0, 0, 103, 101, 116, 70, 101, 97, 116,
117, 114, 101, 82, 101, 113, 117, 101, 115, 116, 115, 0,
0, 1, 0, 0, 0, 0, 5, 0, 0, 0, 90, 234, 182, 21, 99, 114,
101, 97, 116, 101, 70, 101, 97, 116, 117, 114, 101, 82,
101, 113, 117, 101, 115, 116, 0, 0, 0, 4, 0, 0, 0, 4, 0,
0, 0, 122, 198, 200, 166, 100, 101, 108, 101, 116, 101,
70, 101, 97, 116, 117, 114, 101, 82, 101, 113, 117, 101,
115, 116, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 141, 216, 230,
68, 118, 111, 116, 101, 0, 0, 0, 6, 0, 0, 0, 0, 0, 0, 0,
80, 232, 8, 162, 103, 101, 116, 82, 101, 119, 97, 114,
100, 0, 0, 0, 7, 0, 0, 0, 9, 0, 0, 0, 55, 9, 180, 88, 105,
115, 69, 118, 101, 110, 116, 65, 99, 116, 105, 118, 101,
0, 0, 0, 10, 0, 0, 0, 11, 0, 0, 0, 137, 127, 29, 240, 116,
101, 115, 116, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 24, 168,
65, 195
]);


export interface IEmpty extends BebopRecord {
}

export class Empty implements IEmpty {

  constructor(record: IEmpty) {
  }

  /**
   * Serializes the current instance into a JSON-Over-Bebop string
   */
  public stringify(): string {
    return Empty.encodeToJSON(this);
  }

  /**
   * Serializes the specified object into a JSON-Over-Bebop string
   */
  public static encodeToJSON(record: IEmpty): string {
    return JSON.stringify(record, BebopJson.replacer);
  }

  /**
   * Validates that the runtime types of members in the current instance are correct.
   */
  public validateTypes(): void {
    Empty.validateCompatibility(this);
  }

  /**
   * Validates that the specified dynamic object can become an instance of {@link Empty}.
   */
  public static validateCompatibility(record: IEmpty): void {

  }

  /**
   * Unsafely creates an instance of {@link Empty} from the specified dynamic object. No type checking is performed.
   */
  public static unsafeCast(record: any): IEmpty {
      return new Empty(record);
  }

  /**
   * Creates a new {@link Empty} instance from a JSON-Over-Bebop string. Type checking is performed.
   */
  public static fromJSON(json: string): IEmpty {
    if (typeof json !== 'string' || json.trim().length === 0) {
      throw new BebopRuntimeError(`Empty.fromJSON: expected string`);
    }
    const parsed = JSON.parse(json, BebopJson.reviver);
    Empty.validateCompatibility(parsed);
    return Empty.unsafeCast(parsed);
  }
  public encode(): Uint8Array {
    return Empty.encode(this);
  }

  public static encode(record: IEmpty): Uint8Array {
    const view = BebopView.getInstance();
    view.startWriting();
    Empty.encodeInto(record, view);
    return view.toArray();
  }

  public static encodeInto(record: IEmpty, view: BebopView): number {
    const before = view.length;

    const after = view.length;
    return after - before;
  }

  public static decode(buffer: Uint8Array): IEmpty {
    const view = BebopView.getInstance();
    view.startReading(buffer);
    return Empty.readFrom(view);
  }

  public static readFrom(view: BebopView): IEmpty {
    let message: IEmpty = {
    };
    return new Empty(message);
  }
}


export interface ITokenPayload extends BebopRecord {

  readonly exp: Date;

  readonly data: IUser;
}

export class TokenPayload implements ITokenPayload {
  public readonly exp: Date;
  public readonly data: IUser;

  constructor(record: ITokenPayload) {
    this.exp = record.exp;
    this.data = record.data;
  }

  /**
   * Serializes the current instance into a JSON-Over-Bebop string
   */
  public stringify(): string {
    return TokenPayload.encodeToJSON(this);
  }

  /**
   * Serializes the specified object into a JSON-Over-Bebop string
   */
  public static encodeToJSON(record: ITokenPayload): string {
    return JSON.stringify(record, BebopJson.replacer);
  }

  /**
   * Validates that the runtime types of members in the current instance are correct.
   */
  public validateTypes(): void {
    TokenPayload.validateCompatibility(this);
  }

  /**
   * Validates that the specified dynamic object can become an instance of {@link TokenPayload}.
   */
  public static validateCompatibility(record: ITokenPayload): void {
    BebopTypeGuard.ensureDate(record.exp)
    User.validateCompatibility(record.data);
  }

  /**
   * Unsafely creates an instance of {@link TokenPayload} from the specified dynamic object. No type checking is performed.
   */
  public static unsafeCast(record: any): ITokenPayload {
      record.data = User.unsafeCast(record.data);
      return new TokenPayload(record);
  }

  /**
   * Creates a new {@link TokenPayload} instance from a JSON-Over-Bebop string. Type checking is performed.
   */
  public static fromJSON(json: string): ITokenPayload {
    if (typeof json !== 'string' || json.trim().length === 0) {
      throw new BebopRuntimeError(`TokenPayload.fromJSON: expected string`);
    }
    const parsed = JSON.parse(json, BebopJson.reviver);
    TokenPayload.validateCompatibility(parsed);
    return TokenPayload.unsafeCast(parsed);
  }
  public encode(): Uint8Array {
    return TokenPayload.encode(this);
  }

  public static encode(record: ITokenPayload): Uint8Array {
    const view = BebopView.getInstance();
    view.startWriting();
    TokenPayload.encodeInto(record, view);
    return view.toArray();
  }

  public static encodeInto(record: ITokenPayload, view: BebopView): number {
    const before = view.length;
    view.writeDate(record.exp);
    User.encodeInto(record.data, view)
    const after = view.length;
    return after - before;
  }

  public static decode(buffer: Uint8Array): ITokenPayload {
    const view = BebopView.getInstance();
    view.startReading(buffer);
    return TokenPayload.readFrom(view);
  }

  public static readFrom(view: BebopView): ITokenPayload {
    let field0: Date;
    field0 = view.readDate();
    let field1: IUser;
    field1 = User.readFrom(view);
    let message: ITokenPayload = {
      exp: field0,
      data: field1,
    };
    return new TokenPayload(message);
  }
}

/**
 * A status for a feature request
 */
export enum FeatureRequestStatus {
  /**
   * The request has not been reviewed yet
   */
  None = 0,
  /**
   * The request is pending review
   */
  Pending = 1,
  /**
   * The request has been accepted
   */
  Accepted = 2,
  /**
   * The request has been rejected
   */
  Rejected = 3,
}

/**
 * A user on Steam
 */
export interface IUser extends BebopRecord {
  /**
   * The user's SteamID
   */
  readonly id: bigint;
  /**
   * The user's name
   */
  readonly name: string;
  /**
   * The user's level on Steam
   */
  readonly level: number;
  /**
   * The user's profile picture (URL)
   */
  readonly avatar: string;
  /**
   * The user's playtime in the app
   */
  readonly playTime: number;
  /**
   * A list of the app ids the user owns
   */
  readonly ownedApps: Array<number>;
  /**
   * The amount of weight the user has in the feature request system (0-100)
   */
  readonly weight: number;
  /**
   * The user's profile URL on Steam
   */
  readonly profileUrl: string;
}

export class User implements IUser {
  public readonly id: bigint;
  public readonly name: string;
  public readonly level: number;
  public readonly avatar: string;
  public readonly playTime: number;
  public readonly ownedApps: Array<number>;
  public readonly weight: number;
  public readonly profileUrl: string;

  constructor(record: IUser) {
    this.id = record.id;
    this.name = record.name;
    this.level = record.level;
    this.avatar = record.avatar;
    this.playTime = record.playTime;
    this.ownedApps = record.ownedApps;
    this.weight = record.weight;
    this.profileUrl = record.profileUrl;
  }

  /**
   * Serializes the current instance into a JSON-Over-Bebop string
   */
  public stringify(): string {
    return User.encodeToJSON(this);
  }

  /**
   * Serializes the specified object into a JSON-Over-Bebop string
   */
  public static encodeToJSON(record: IUser): string {
    return JSON.stringify(record, BebopJson.replacer);
  }

  /**
   * Validates that the runtime types of members in the current instance are correct.
   */
  public validateTypes(): void {
    User.validateCompatibility(this);
  }

  /**
   * Validates that the specified dynamic object can become an instance of {@link User}.
   */
  public static validateCompatibility(record: IUser): void {
    BebopTypeGuard.ensureUint64(record.id)
    BebopTypeGuard.ensureString(record.name)
    BebopTypeGuard.ensureUint16(record.level)
    BebopTypeGuard.ensureString(record.avatar)
    BebopTypeGuard.ensureUint32(record.playTime)
    BebopTypeGuard.ensureArray(record.ownedApps, BebopTypeGuard.ensureUint32);
    BebopTypeGuard.ensureUint8(record.weight)
    BebopTypeGuard.ensureString(record.profileUrl)
  }

  /**
   * Unsafely creates an instance of {@link User} from the specified dynamic object. No type checking is performed.
   */
  public static unsafeCast(record: any): IUser {
      return new User(record);
  }

  /**
   * Creates a new {@link User} instance from a JSON-Over-Bebop string. Type checking is performed.
   */
  public static fromJSON(json: string): IUser {
    if (typeof json !== 'string' || json.trim().length === 0) {
      throw new BebopRuntimeError(`User.fromJSON: expected string`);
    }
    const parsed = JSON.parse(json, BebopJson.reviver);
    User.validateCompatibility(parsed);
    return User.unsafeCast(parsed);
  }
  public encode(): Uint8Array {
    return User.encode(this);
  }

  public static encode(record: IUser): Uint8Array {
    const view = BebopView.getInstance();
    view.startWriting();
    User.encodeInto(record, view);
    return view.toArray();
  }

  public static encodeInto(record: IUser, view: BebopView): number {
    const before = view.length;
    view.writeUint64(record.id);
    view.writeString(record.name);
    view.writeUint16(record.level);
    view.writeString(record.avatar);
    view.writeUint32(record.playTime);
    {
      const length0 = record.ownedApps.length;
      view.writeUint32(length0);
      for (let i0 = 0; i0 < length0; i0++) {
        view.writeUint32(record.ownedApps[i0]);
      }
    }
    view.writeByte(record.weight);
    view.writeString(record.profileUrl);
    const after = view.length;
    return after - before;
  }

  public static decode(buffer: Uint8Array): IUser {
    const view = BebopView.getInstance();
    view.startReading(buffer);
    return User.readFrom(view);
  }

  public static readFrom(view: BebopView): IUser {
    let field0: bigint;
    field0 = view.readUint64();
    let field1: string;
    field1 = view.readString();
    let field2: number;
    field2 = view.readUint16();
    let field3: string;
    field3 = view.readString();
    let field4: number;
    field4 = view.readUint32();
    let field5: Array<number>;
    {
      let length0 = view.readUint32();
      field5 = new Array<number>(length0);
      for (let i0 = 0; i0 < length0; i0++) {
        let x0: number;
        x0 = view.readUint32();
        field5[i0] = x0;
      }
    }
    let field6: number;
    field6 = view.readByte();
    let field7: string;
    field7 = view.readString();
    let message: IUser = {
      id: field0,
      name: field1,
      level: field2,
      avatar: field3,
      playTime: field4,
      ownedApps: field5,
      weight: field6,
      profileUrl: field7,
    };
    return new User(message);
  }
}

/**
 * A feature request
 */
export interface IFeatureRequest extends BebopRecord {
  /**
   * A unique id for the feature request
   */
  id?: Guid;
  /**
   * The Steam ID of the user who created the request
   */
  creatorId?: bigint;
  /**
   * The amount of upvotes the request has
   */
  upvotes?: number;
  /**
   * The amount of downvotes the request has
   */
  downvotes?: number;
  /**
   * The status of the request
   */
  status?: FeatureRequestStatus;
  /**
   * The title of the request
   */
  title?: string;
  /**
   * The description of the request
   */
  description?: string;
  /**
   * The date the request was created
   */
  created?: Date;
  /**
   * The date the request was last updated
   */
  updated?: Date;
  /**
   * The amount of weight the request has (0-100)
   */
  weight?: number;
  /**
   * Whether the request is pinned
   */
  pinned?: boolean;
}

export class FeatureRequest implements IFeatureRequest {
  public id?: Guid;
  public creatorId?: bigint;
  public upvotes?: number;
  public downvotes?: number;
  public status?: FeatureRequestStatus;
  public title?: string;
  public description?: string;
  public created?: Date;
  public updated?: Date;
  public weight?: number;
  public pinned?: boolean;

  constructor(record: IFeatureRequest) {
    this.id = record.id;
    this.creatorId = record.creatorId;
    this.upvotes = record.upvotes;
    this.downvotes = record.downvotes;
    this.status = record.status;
    this.title = record.title;
    this.description = record.description;
    this.created = record.created;
    this.updated = record.updated;
    this.weight = record.weight;
    this.pinned = record.pinned;
  }

  /**
   * Serializes the current instance into a JSON-Over-Bebop string
   */
  public stringify(): string {
    return FeatureRequest.encodeToJSON(this);
  }

  /**
   * Serializes the specified object into a JSON-Over-Bebop string
   */
  public static encodeToJSON(record: IFeatureRequest): string {
    return JSON.stringify(record, BebopJson.replacer);
  }

  /**
   * Validates that the runtime types of members in the current instance are correct.
   */
  public validateTypes(): void {
    FeatureRequest.validateCompatibility(this);
  }

  /**
   * Validates that the specified dynamic object can become an instance of {@link FeatureRequest}.
   */
  public static validateCompatibility(record: IFeatureRequest): void {
    if (record.id !== undefined) {
      BebopTypeGuard.ensureGuid(record.id)
    }
    if (record.creatorId !== undefined) {
      BebopTypeGuard.ensureUint64(record.creatorId)
    }
    if (record.upvotes !== undefined) {
      BebopTypeGuard.ensureUint32(record.upvotes)
    }
    if (record.downvotes !== undefined) {
      BebopTypeGuard.ensureUint32(record.downvotes)
    }
    if (record.status !== undefined) {
      BebopTypeGuard.ensureEnum(record.status, FeatureRequestStatus);
    }
    if (record.title !== undefined) {
      BebopTypeGuard.ensureString(record.title)
    }
    if (record.description !== undefined) {
      BebopTypeGuard.ensureString(record.description)
    }
    if (record.created !== undefined) {
      BebopTypeGuard.ensureDate(record.created)
    }
    if (record.updated !== undefined) {
      BebopTypeGuard.ensureDate(record.updated)
    }
    if (record.weight !== undefined) {
      BebopTypeGuard.ensureUint8(record.weight)
    }
    if (record.pinned !== undefined) {
      BebopTypeGuard.ensureBoolean(record.pinned)
    }
  }

  /**
   * Unsafely creates an instance of {@link FeatureRequest} from the specified dynamic object. No type checking is performed.
   */
  public static unsafeCast(record: any): IFeatureRequest {
      return new FeatureRequest(record);
  }

  /**
   * Creates a new {@link FeatureRequest} instance from a JSON-Over-Bebop string. Type checking is performed.
   */
  public static fromJSON(json: string): IFeatureRequest {
    if (typeof json !== 'string' || json.trim().length === 0) {
      throw new BebopRuntimeError(`FeatureRequest.fromJSON: expected string`);
    }
    const parsed = JSON.parse(json, BebopJson.reviver);
    FeatureRequest.validateCompatibility(parsed);
    return FeatureRequest.unsafeCast(parsed);
  }
  public encode(): Uint8Array {
    return FeatureRequest.encode(this);
  }

  public static encode(record: IFeatureRequest): Uint8Array {
    const view = BebopView.getInstance();
    view.startWriting();
    FeatureRequest.encodeInto(record, view);
    return view.toArray();
  }

  public static encodeInto(record: IFeatureRequest, view: BebopView): number {
    const before = view.length;
    const pos = view.reserveMessageLength();
    const start = view.length;
    if (record.id !== undefined) {
      view.writeByte(1);
      view.writeGuid(record.id);
    }
    if (record.creatorId !== undefined) {
      view.writeByte(2);
      view.writeUint64(record.creatorId);
    }
    if (record.upvotes !== undefined) {
      view.writeByte(3);
      view.writeUint32(record.upvotes);
    }
    if (record.downvotes !== undefined) {
      view.writeByte(4);
      view.writeUint32(record.downvotes);
    }
    if (record.status !== undefined) {
      view.writeByte(5);
      view.writeUint32(record.status);
    }
    if (record.title !== undefined) {
      view.writeByte(6);
      view.writeString(record.title);
    }
    if (record.description !== undefined) {
      view.writeByte(7);
      view.writeString(record.description);
    }
    if (record.created !== undefined) {
      view.writeByte(8);
      view.writeDate(record.created);
    }
    if (record.updated !== undefined) {
      view.writeByte(9);
      view.writeDate(record.updated);
    }
    if (record.weight !== undefined) {
      view.writeByte(10);
      view.writeByte(record.weight);
    }
    if (record.pinned !== undefined) {
      view.writeByte(11);
      view.writeByte(Number(record.pinned));
    }
    view.writeByte(0);
    const end = view.length;
    view.fillMessageLength(pos, end - start);
    const after = view.length;
    return after - before;
  }

  public static decode(buffer: Uint8Array): IFeatureRequest {
    const view = BebopView.getInstance();
    view.startReading(buffer);
    return FeatureRequest.readFrom(view);
  }

  public static readFrom(view: BebopView): IFeatureRequest {
    let message: IFeatureRequest = {};
    const length = view.readMessageLength();
    const end = view.index + length;
    while (true) {
      switch (view.readByte()) {
        case 0:
          return new FeatureRequest(message);

        case 1:
          message.id = view.readGuid();
          break;

        case 2:
          message.creatorId = view.readUint64();
          break;

        case 3:
          message.upvotes = view.readUint32();
          break;

        case 4:
          message.downvotes = view.readUint32();
          break;

        case 5:
          message.status = view.readUint32() as FeatureRequestStatus;
          break;

        case 6:
          message.title = view.readString();
          break;

        case 7:
          message.description = view.readString();
          break;

        case 8:
          message.created = view.readDate();
          break;

        case 9:
          message.updated = view.readDate();
          break;

        case 10:
          message.weight = view.readByte();
          break;

        case 11:
          message.pinned = !!view.readByte();
          break;

        default:
          view.index = end;
          return new FeatureRequest(message);
      }
    }
  }
}


export interface IFeatureRequestResponse extends BebopRecord {

  readonly request: IFeatureRequest;

  readonly creator: IUser;

  readonly userVote: number;
}

export class FeatureRequestResponse implements IFeatureRequestResponse {
  public readonly request: IFeatureRequest;
  public readonly creator: IUser;
  public readonly userVote: number;

  constructor(record: IFeatureRequestResponse) {
    this.request = record.request;
    this.creator = record.creator;
    this.userVote = record.userVote;
  }

  /**
   * Serializes the current instance into a JSON-Over-Bebop string
   */
  public stringify(): string {
    return FeatureRequestResponse.encodeToJSON(this);
  }

  /**
   * Serializes the specified object into a JSON-Over-Bebop string
   */
  public static encodeToJSON(record: IFeatureRequestResponse): string {
    return JSON.stringify(record, BebopJson.replacer);
  }

  /**
   * Validates that the runtime types of members in the current instance are correct.
   */
  public validateTypes(): void {
    FeatureRequestResponse.validateCompatibility(this);
  }

  /**
   * Validates that the specified dynamic object can become an instance of {@link FeatureRequestResponse}.
   */
  public static validateCompatibility(record: IFeatureRequestResponse): void {
    FeatureRequest.validateCompatibility(record.request);
    User.validateCompatibility(record.creator);
    BebopTypeGuard.ensureUint8(record.userVote)
  }

  /**
   * Unsafely creates an instance of {@link FeatureRequestResponse} from the specified dynamic object. No type checking is performed.
   */
  public static unsafeCast(record: any): IFeatureRequestResponse {
      record.request = FeatureRequest.unsafeCast(record.request);
      record.creator = User.unsafeCast(record.creator);
      return new FeatureRequestResponse(record);
  }

  /**
   * Creates a new {@link FeatureRequestResponse} instance from a JSON-Over-Bebop string. Type checking is performed.
   */
  public static fromJSON(json: string): IFeatureRequestResponse {
    if (typeof json !== 'string' || json.trim().length === 0) {
      throw new BebopRuntimeError(`FeatureRequestResponse.fromJSON: expected string`);
    }
    const parsed = JSON.parse(json, BebopJson.reviver);
    FeatureRequestResponse.validateCompatibility(parsed);
    return FeatureRequestResponse.unsafeCast(parsed);
  }
  public encode(): Uint8Array {
    return FeatureRequestResponse.encode(this);
  }

  public static encode(record: IFeatureRequestResponse): Uint8Array {
    const view = BebopView.getInstance();
    view.startWriting();
    FeatureRequestResponse.encodeInto(record, view);
    return view.toArray();
  }

  public static encodeInto(record: IFeatureRequestResponse, view: BebopView): number {
    const before = view.length;
    FeatureRequest.encodeInto(record.request, view)
    User.encodeInto(record.creator, view)
    view.writeByte(record.userVote);
    const after = view.length;
    return after - before;
  }

  public static decode(buffer: Uint8Array): IFeatureRequestResponse {
    const view = BebopView.getInstance();
    view.startReading(buffer);
    return FeatureRequestResponse.readFrom(view);
  }

  public static readFrom(view: BebopView): IFeatureRequestResponse {
    let field0: IFeatureRequest;
    field0 = FeatureRequest.readFrom(view);
    let field1: IUser;
    field1 = User.readFrom(view);
    let field2: number;
    field2 = view.readByte();
    let message: IFeatureRequestResponse = {
      request: field0,
      creator: field1,
      userVote: field2,
    };
    return new FeatureRequestResponse(message);
  }
}


export interface IVoteRequest extends BebopRecord {

  readonly featureRequestId: Guid;

  readonly vote: number;
}

export class VoteRequest implements IVoteRequest {
  public readonly featureRequestId: Guid;
  public readonly vote: number;

  constructor(record: IVoteRequest) {
    this.featureRequestId = record.featureRequestId;
    this.vote = record.vote;
  }

  /**
   * Serializes the current instance into a JSON-Over-Bebop string
   */
  public stringify(): string {
    return VoteRequest.encodeToJSON(this);
  }

  /**
   * Serializes the specified object into a JSON-Over-Bebop string
   */
  public static encodeToJSON(record: IVoteRequest): string {
    return JSON.stringify(record, BebopJson.replacer);
  }

  /**
   * Validates that the runtime types of members in the current instance are correct.
   */
  public validateTypes(): void {
    VoteRequest.validateCompatibility(this);
  }

  /**
   * Validates that the specified dynamic object can become an instance of {@link VoteRequest}.
   */
  public static validateCompatibility(record: IVoteRequest): void {
    BebopTypeGuard.ensureGuid(record.featureRequestId)
    BebopTypeGuard.ensureUint8(record.vote)
  }

  /**
   * Unsafely creates an instance of {@link VoteRequest} from the specified dynamic object. No type checking is performed.
   */
  public static unsafeCast(record: any): IVoteRequest {
      return new VoteRequest(record);
  }

  /**
   * Creates a new {@link VoteRequest} instance from a JSON-Over-Bebop string. Type checking is performed.
   */
  public static fromJSON(json: string): IVoteRequest {
    if (typeof json !== 'string' || json.trim().length === 0) {
      throw new BebopRuntimeError(`VoteRequest.fromJSON: expected string`);
    }
    const parsed = JSON.parse(json, BebopJson.reviver);
    VoteRequest.validateCompatibility(parsed);
    return VoteRequest.unsafeCast(parsed);
  }
  public encode(): Uint8Array {
    return VoteRequest.encode(this);
  }

  public static encode(record: IVoteRequest): Uint8Array {
    const view = BebopView.getInstance();
    view.startWriting();
    VoteRequest.encodeInto(record, view);
    return view.toArray();
  }

  public static encodeInto(record: IVoteRequest, view: BebopView): number {
    const before = view.length;
    view.writeGuid(record.featureRequestId);
    view.writeByte(record.vote);
    const after = view.length;
    return after - before;
  }

  public static decode(buffer: Uint8Array): IVoteRequest {
    const view = BebopView.getInstance();
    view.startReading(buffer);
    return VoteRequest.readFrom(view);
  }

  public static readFrom(view: BebopView): IVoteRequest {
    let field0: Guid;
    field0 = view.readGuid();
    let field1: number;
    field1 = view.readByte();
    let message: IVoteRequest = {
      featureRequestId: field0,
      vote: field1,
    };
    return new VoteRequest(message);
  }
}


export interface IRewardRequest extends BebopRecord {

  readonly eventId: number;
}

export class RewardRequest implements IRewardRequest {
  public readonly eventId: number;

  constructor(record: IRewardRequest) {
    this.eventId = record.eventId;
  }

  /**
   * Serializes the current instance into a JSON-Over-Bebop string
   */
  public stringify(): string {
    return RewardRequest.encodeToJSON(this);
  }

  /**
   * Serializes the specified object into a JSON-Over-Bebop string
   */
  public static encodeToJSON(record: IRewardRequest): string {
    return JSON.stringify(record, BebopJson.replacer);
  }

  /**
   * Validates that the runtime types of members in the current instance are correct.
   */
  public validateTypes(): void {
    RewardRequest.validateCompatibility(this);
  }

  /**
   * Validates that the specified dynamic object can become an instance of {@link RewardRequest}.
   */
  public static validateCompatibility(record: IRewardRequest): void {
    BebopTypeGuard.ensureUint32(record.eventId)
  }

  /**
   * Unsafely creates an instance of {@link RewardRequest} from the specified dynamic object. No type checking is performed.
   */
  public static unsafeCast(record: any): IRewardRequest {
      return new RewardRequest(record);
  }

  /**
   * Creates a new {@link RewardRequest} instance from a JSON-Over-Bebop string. Type checking is performed.
   */
  public static fromJSON(json: string): IRewardRequest {
    if (typeof json !== 'string' || json.trim().length === 0) {
      throw new BebopRuntimeError(`RewardRequest.fromJSON: expected string`);
    }
    const parsed = JSON.parse(json, BebopJson.reviver);
    RewardRequest.validateCompatibility(parsed);
    return RewardRequest.unsafeCast(parsed);
  }
  public encode(): Uint8Array {
    return RewardRequest.encode(this);
  }

  public static encode(record: IRewardRequest): Uint8Array {
    const view = BebopView.getInstance();
    view.startWriting();
    RewardRequest.encodeInto(record, view);
    return view.toArray();
  }

  public static encodeInto(record: IRewardRequest, view: BebopView): number {
    const before = view.length;
    view.writeUint32(record.eventId);
    const after = view.length;
    return after - before;
  }

  public static decode(buffer: Uint8Array): IRewardRequest {
    const view = BebopView.getInstance();
    view.startReading(buffer);
    return RewardRequest.readFrom(view);
  }

  public static readFrom(view: BebopView): IRewardRequest {
    let field0: number;
    field0 = view.readUint32();
    let message: IRewardRequest = {
      eventId: field0,
    };
    return new RewardRequest(message);
  }
}


export interface IReward extends BebopRecord {

  readonly title: string;

  readonly icon: string;

  readonly content: string;

  readonly backgroundColor: string;
}

export class Reward implements IReward {
  public readonly title: string;
  public readonly icon: string;
  public readonly content: string;
  public readonly backgroundColor: string;

  constructor(record: IReward) {
    this.title = record.title;
    this.icon = record.icon;
    this.content = record.content;
    this.backgroundColor = record.backgroundColor;
  }

  /**
   * Serializes the current instance into a JSON-Over-Bebop string
   */
  public stringify(): string {
    return Reward.encodeToJSON(this);
  }

  /**
   * Serializes the specified object into a JSON-Over-Bebop string
   */
  public static encodeToJSON(record: IReward): string {
    return JSON.stringify(record, BebopJson.replacer);
  }

  /**
   * Validates that the runtime types of members in the current instance are correct.
   */
  public validateTypes(): void {
    Reward.validateCompatibility(this);
  }

  /**
   * Validates that the specified dynamic object can become an instance of {@link Reward}.
   */
  public static validateCompatibility(record: IReward): void {
    BebopTypeGuard.ensureString(record.title)
    BebopTypeGuard.ensureString(record.icon)
    BebopTypeGuard.ensureString(record.content)
    BebopTypeGuard.ensureString(record.backgroundColor)
  }

  /**
   * Unsafely creates an instance of {@link Reward} from the specified dynamic object. No type checking is performed.
   */
  public static unsafeCast(record: any): IReward {
      return new Reward(record);
  }

  /**
   * Creates a new {@link Reward} instance from a JSON-Over-Bebop string. Type checking is performed.
   */
  public static fromJSON(json: string): IReward {
    if (typeof json !== 'string' || json.trim().length === 0) {
      throw new BebopRuntimeError(`Reward.fromJSON: expected string`);
    }
    const parsed = JSON.parse(json, BebopJson.reviver);
    Reward.validateCompatibility(parsed);
    return Reward.unsafeCast(parsed);
  }
  public encode(): Uint8Array {
    return Reward.encode(this);
  }

  public static encode(record: IReward): Uint8Array {
    const view = BebopView.getInstance();
    view.startWriting();
    Reward.encodeInto(record, view);
    return view.toArray();
  }

  public static encodeInto(record: IReward, view: BebopView): number {
    const before = view.length;
    view.writeString(record.title);
    view.writeString(record.icon);
    view.writeString(record.content);
    view.writeString(record.backgroundColor);
    const after = view.length;
    return after - before;
  }

  public static decode(buffer: Uint8Array): IReward {
    const view = BebopView.getInstance();
    view.startReading(buffer);
    return Reward.readFrom(view);
  }

  public static readFrom(view: BebopView): IReward {
    let field0: string;
    field0 = view.readString();
    let field1: string;
    field1 = view.readString();
    let field2: string;
    field2 = view.readString();
    let field3: string;
    field3 = view.readString();
    let message: IReward = {
      title: field0,
      icon: field1,
      content: field2,
      backgroundColor: field3,
    };
    return new Reward(message);
  }
}


export interface IRewardResponse extends BebopRecord {

  reward?: IReward;

  filler?: Array<IReward>;
}

export class RewardResponse implements IRewardResponse {
  public reward?: IReward;
  public filler?: Array<IReward>;

  constructor(record: IRewardResponse) {
    this.reward = record.reward;
    this.filler = record.filler;
  }

  /**
   * Serializes the current instance into a JSON-Over-Bebop string
   */
  public stringify(): string {
    return RewardResponse.encodeToJSON(this);
  }

  /**
   * Serializes the specified object into a JSON-Over-Bebop string
   */
  public static encodeToJSON(record: IRewardResponse): string {
    return JSON.stringify(record, BebopJson.replacer);
  }

  /**
   * Validates that the runtime types of members in the current instance are correct.
   */
  public validateTypes(): void {
    RewardResponse.validateCompatibility(this);
  }

  /**
   * Validates that the specified dynamic object can become an instance of {@link RewardResponse}.
   */
  public static validateCompatibility(record: IRewardResponse): void {
    if (record.reward !== undefined) {
      Reward.validateCompatibility(record.reward);
    }
    if (record.filler !== undefined) {
      BebopTypeGuard.ensureArray(record.filler, Reward.validateCompatibility);
    }
  }

  /**
   * Unsafely creates an instance of {@link RewardResponse} from the specified dynamic object. No type checking is performed.
   */
  public static unsafeCast(record: any): IRewardResponse {
      if (record.reward !== undefined) {
        record.reward = Reward.unsafeCast(record.reward);
      }
      return new RewardResponse(record);
  }

  /**
   * Creates a new {@link RewardResponse} instance from a JSON-Over-Bebop string. Type checking is performed.
   */
  public static fromJSON(json: string): IRewardResponse {
    if (typeof json !== 'string' || json.trim().length === 0) {
      throw new BebopRuntimeError(`RewardResponse.fromJSON: expected string`);
    }
    const parsed = JSON.parse(json, BebopJson.reviver);
    RewardResponse.validateCompatibility(parsed);
    return RewardResponse.unsafeCast(parsed);
  }
  public encode(): Uint8Array {
    return RewardResponse.encode(this);
  }

  public static encode(record: IRewardResponse): Uint8Array {
    const view = BebopView.getInstance();
    view.startWriting();
    RewardResponse.encodeInto(record, view);
    return view.toArray();
  }

  public static encodeInto(record: IRewardResponse, view: BebopView): number {
    const before = view.length;
    const pos = view.reserveMessageLength();
    const start = view.length;
    if (record.reward !== undefined) {
      view.writeByte(1);
      Reward.encodeInto(record.reward, view)
    }
    if (record.filler !== undefined) {
      view.writeByte(2);
      {
      const length0 = record.filler.length;
      view.writeUint32(length0);
      for (let i0 = 0; i0 < length0; i0++) {
        Reward.encodeInto(record.filler[i0], view)
      }
    }
    }
    view.writeByte(0);
    const end = view.length;
    view.fillMessageLength(pos, end - start);
    const after = view.length;
    return after - before;
  }

  public static decode(buffer: Uint8Array): IRewardResponse {
    const view = BebopView.getInstance();
    view.startReading(buffer);
    return RewardResponse.readFrom(view);
  }

  public static readFrom(view: BebopView): IRewardResponse {
    let message: IRewardResponse = {};
    const length = view.readMessageLength();
    const end = view.index + length;
    while (true) {
      switch (view.readByte()) {
        case 0:
          return new RewardResponse(message);

        case 1:
          message.reward = Reward.readFrom(view);
          break;

        case 2:
          {
        let length0 = view.readUint32();
        message.filler = new Array<IReward>(length0);
        for (let i0 = 0; i0 < length0; i0++) {
          let x0: IReward;
          x0 = Reward.readFrom(view);
          message.filler[i0] = x0;
        }
      }
          break;

        default:
          view.index = end;
          return new RewardResponse(message);
      }
    }
  }
}


export interface IIsEventActiveRequest extends BebopRecord {

  readonly eventId: number;
}

export class IsEventActiveRequest implements IIsEventActiveRequest {
  public readonly eventId: number;

  constructor(record: IIsEventActiveRequest) {
    this.eventId = record.eventId;
  }

  /**
   * Serializes the current instance into a JSON-Over-Bebop string
   */
  public stringify(): string {
    return IsEventActiveRequest.encodeToJSON(this);
  }

  /**
   * Serializes the specified object into a JSON-Over-Bebop string
   */
  public static encodeToJSON(record: IIsEventActiveRequest): string {
    return JSON.stringify(record, BebopJson.replacer);
  }

  /**
   * Validates that the runtime types of members in the current instance are correct.
   */
  public validateTypes(): void {
    IsEventActiveRequest.validateCompatibility(this);
  }

  /**
   * Validates that the specified dynamic object can become an instance of {@link IsEventActiveRequest}.
   */
  public static validateCompatibility(record: IIsEventActiveRequest): void {
    BebopTypeGuard.ensureUint32(record.eventId)
  }

  /**
   * Unsafely creates an instance of {@link IsEventActiveRequest} from the specified dynamic object. No type checking is performed.
   */
  public static unsafeCast(record: any): IIsEventActiveRequest {
      return new IsEventActiveRequest(record);
  }

  /**
   * Creates a new {@link IsEventActiveRequest} instance from a JSON-Over-Bebop string. Type checking is performed.
   */
  public static fromJSON(json: string): IIsEventActiveRequest {
    if (typeof json !== 'string' || json.trim().length === 0) {
      throw new BebopRuntimeError(`IsEventActiveRequest.fromJSON: expected string`);
    }
    const parsed = JSON.parse(json, BebopJson.reviver);
    IsEventActiveRequest.validateCompatibility(parsed);
    return IsEventActiveRequest.unsafeCast(parsed);
  }
  public encode(): Uint8Array {
    return IsEventActiveRequest.encode(this);
  }

  public static encode(record: IIsEventActiveRequest): Uint8Array {
    const view = BebopView.getInstance();
    view.startWriting();
    IsEventActiveRequest.encodeInto(record, view);
    return view.toArray();
  }

  public static encodeInto(record: IIsEventActiveRequest, view: BebopView): number {
    const before = view.length;
    view.writeUint32(record.eventId);
    const after = view.length;
    return after - before;
  }

  public static decode(buffer: Uint8Array): IIsEventActiveRequest {
    const view = BebopView.getInstance();
    view.startReading(buffer);
    return IsEventActiveRequest.readFrom(view);
  }

  public static readFrom(view: BebopView): IIsEventActiveRequest {
    let field0: number;
    field0 = view.readUint32();
    let message: IIsEventActiveRequest = {
      eventId: field0,
    };
    return new IsEventActiveRequest(message);
  }
}


export interface IIsEventActiveResponse extends BebopRecord {

  readonly isActive: boolean;
}

export class IsEventActiveResponse implements IIsEventActiveResponse {
  public readonly isActive: boolean;

  constructor(record: IIsEventActiveResponse) {
    this.isActive = record.isActive;
  }

  /**
   * Serializes the current instance into a JSON-Over-Bebop string
   */
  public stringify(): string {
    return IsEventActiveResponse.encodeToJSON(this);
  }

  /**
   * Serializes the specified object into a JSON-Over-Bebop string
   */
  public static encodeToJSON(record: IIsEventActiveResponse): string {
    return JSON.stringify(record, BebopJson.replacer);
  }

  /**
   * Validates that the runtime types of members in the current instance are correct.
   */
  public validateTypes(): void {
    IsEventActiveResponse.validateCompatibility(this);
  }

  /**
   * Validates that the specified dynamic object can become an instance of {@link IsEventActiveResponse}.
   */
  public static validateCompatibility(record: IIsEventActiveResponse): void {
    BebopTypeGuard.ensureBoolean(record.isActive)
  }

  /**
   * Unsafely creates an instance of {@link IsEventActiveResponse} from the specified dynamic object. No type checking is performed.
   */
  public static unsafeCast(record: any): IIsEventActiveResponse {
      return new IsEventActiveResponse(record);
  }

  /**
   * Creates a new {@link IsEventActiveResponse} instance from a JSON-Over-Bebop string. Type checking is performed.
   */
  public static fromJSON(json: string): IIsEventActiveResponse {
    if (typeof json !== 'string' || json.trim().length === 0) {
      throw new BebopRuntimeError(`IsEventActiveResponse.fromJSON: expected string`);
    }
    const parsed = JSON.parse(json, BebopJson.reviver);
    IsEventActiveResponse.validateCompatibility(parsed);
    return IsEventActiveResponse.unsafeCast(parsed);
  }
  public encode(): Uint8Array {
    return IsEventActiveResponse.encode(this);
  }

  public static encode(record: IIsEventActiveResponse): Uint8Array {
    const view = BebopView.getInstance();
    view.startWriting();
    IsEventActiveResponse.encodeInto(record, view);
    return view.toArray();
  }

  public static encodeInto(record: IIsEventActiveResponse, view: BebopView): number {
    const before = view.length;
    view.writeByte(Number(record.isActive));
    const after = view.length;
    return after - before;
  }

  public static decode(buffer: Uint8Array): IIsEventActiveResponse {
    const view = BebopView.getInstance();
    view.startReading(buffer);
    return IsEventActiveResponse.readFrom(view);
  }

  public static readFrom(view: BebopView): IIsEventActiveResponse {
    let field0: boolean;
    field0 = !!view.readByte();
    let message: IIsEventActiveResponse = {
      isActive: field0,
    };
    return new IsEventActiveResponse(message);
  }
}

/**
 * A service for managing feature requests
 */
/**
 * A service for managing feature requests
 */
export interface IVoiceClient {
  /**
   * Gets all feature request
   */
  getFeatureRequests(request: IEmpty): Promise<AsyncGenerator<IFeatureRequestResponse, void, undefined>>;
  getFeatureRequests(request: IEmpty, metadata: Metadata): Promise<AsyncGenerator<IFeatureRequestResponse, void, undefined>>;

  createFeatureRequest(request: IFeatureRequest): Promise<IFeatureRequest>;
  createFeatureRequest(request: IFeatureRequest, metadata: Metadata): Promise<IFeatureRequest>;

  deleteFeatureRequest(request: IFeatureRequest): Promise<IEmpty>;
  deleteFeatureRequest(request: IFeatureRequest, metadata: Metadata): Promise<IEmpty>;

  vote(request: IVoteRequest): Promise<IEmpty>;
  vote(request: IVoteRequest, metadata: Metadata): Promise<IEmpty>;

  getReward(request: IRewardRequest): Promise<IRewardResponse>;
  getReward(request: IRewardRequest, metadata: Metadata): Promise<IRewardResponse>;

  isEventActive(request: IIsEventActiveRequest): Promise<IIsEventActiveResponse>;
  isEventActive(request: IIsEventActiveRequest, metadata: Metadata): Promise<IIsEventActiveResponse>;

  test(request: IEmpty): Promise<IUser>;
  test(request: IEmpty, metadata: Metadata): Promise<IUser>;
}

/**
 * A service for managing feature requests
 */
export class VoiceClient extends BaseClient implements IVoiceClient {
  private static readonly getFeatureRequestsMethodInfo: MethodInfo<IEmpty, IFeatureRequestResponse> = {
    name: 'getFeatureRequests',
    service: 'VoiceService',
    id: 364309082,
    serialize: Empty.encode,
    deserialize: FeatureRequestResponse.decode,
    stringify: Empty.encodeToJSON,
    fromJSON: FeatureRequestResponse.fromJSON,
    type: MethodType.ServerStream,
  }
  /**
   * Gets all feature request
   */
  async getFeatureRequests(request: IEmpty): Promise<AsyncGenerator<IFeatureRequestResponse, void, undefined>>;
  async getFeatureRequests(request: IEmpty, options: CallOptions): Promise<AsyncGenerator<IFeatureRequestResponse, void, undefined>>;
  async getFeatureRequests(request: IEmpty, options?: CallOptions): Promise<AsyncGenerator<IFeatureRequestResponse, void, undefined>> {
    return await this.channel.startServerStream(request, this.getContext(), VoiceClient.getFeatureRequestsMethodInfo, options);
  }
  private static readonly createFeatureRequestMethodInfo: MethodInfo<IFeatureRequest, IFeatureRequest> = {
    name: 'createFeatureRequest',
    service: 'VoiceService',
    id: 2798175866,
    serialize: FeatureRequest.encode,
    deserialize: FeatureRequest.decode,
    stringify: FeatureRequest.encodeToJSON,
    fromJSON: FeatureRequest.fromJSON,
    type: MethodType.Unary,
  }

  async createFeatureRequest(request: IFeatureRequest): Promise<IFeatureRequest>;
  async createFeatureRequest(request: IFeatureRequest, options: CallOptions): Promise<IFeatureRequest>;
  async createFeatureRequest(request: IFeatureRequest, options?: CallOptions): Promise<IFeatureRequest> {
    return await this.channel.startUnary(request, this.getContext(), VoiceClient.createFeatureRequestMethodInfo, options);
  }
  private static readonly deleteFeatureRequestMethodInfo: MethodInfo<IFeatureRequest, IEmpty> = {
    name: 'deleteFeatureRequest',
    service: 'VoiceService',
    id: 1155979405,
    serialize: FeatureRequest.encode,
    deserialize: Empty.decode,
    stringify: FeatureRequest.encodeToJSON,
    fromJSON: Empty.fromJSON,
    type: MethodType.Unary,
  }

  async deleteFeatureRequest(request: IFeatureRequest): Promise<IEmpty>;
  async deleteFeatureRequest(request: IFeatureRequest, options: CallOptions): Promise<IEmpty>;
  async deleteFeatureRequest(request: IFeatureRequest, options?: CallOptions): Promise<IEmpty> {
    return await this.channel.startUnary(request, this.getContext(), VoiceClient.deleteFeatureRequestMethodInfo, options);
  }
  private static readonly voteMethodInfo: MethodInfo<IVoteRequest, IEmpty> = {
    name: 'vote',
    service: 'VoiceService',
    id: 2718492752,
    serialize: VoteRequest.encode,
    deserialize: Empty.decode,
    stringify: VoteRequest.encodeToJSON,
    fromJSON: Empty.fromJSON,
    type: MethodType.Unary,
  }

  async vote(request: IVoteRequest): Promise<IEmpty>;
  async vote(request: IVoteRequest, options: CallOptions): Promise<IEmpty>;
  async vote(request: IVoteRequest, options?: CallOptions): Promise<IEmpty> {
    return await this.channel.startUnary(request, this.getContext(), VoiceClient.voteMethodInfo, options);
  }
  private static readonly getRewardMethodInfo: MethodInfo<IRewardRequest, IRewardResponse> = {
    name: 'getReward',
    service: 'VoiceService',
    id: 1488193847,
    serialize: RewardRequest.encode,
    deserialize: RewardResponse.decode,
    stringify: RewardRequest.encodeToJSON,
    fromJSON: RewardResponse.fromJSON,
    type: MethodType.Unary,
  }

  async getReward(request: IRewardRequest): Promise<IRewardResponse>;
  async getReward(request: IRewardRequest, options: CallOptions): Promise<IRewardResponse>;
  async getReward(request: IRewardRequest, options?: CallOptions): Promise<IRewardResponse> {
    return await this.channel.startUnary(request, this.getContext(), VoiceClient.getRewardMethodInfo, options);
  }
  private static readonly isEventActiveMethodInfo: MethodInfo<IIsEventActiveRequest, IIsEventActiveResponse> = {
    name: 'isEventActive',
    service: 'VoiceService',
    id: 4028465033,
    serialize: IsEventActiveRequest.encode,
    deserialize: IsEventActiveResponse.decode,
    stringify: IsEventActiveRequest.encodeToJSON,
    fromJSON: IsEventActiveResponse.fromJSON,
    type: MethodType.Unary,
  }

  async isEventActive(request: IIsEventActiveRequest): Promise<IIsEventActiveResponse>;
  async isEventActive(request: IIsEventActiveRequest, options: CallOptions): Promise<IIsEventActiveResponse>;
  async isEventActive(request: IIsEventActiveRequest, options?: CallOptions): Promise<IIsEventActiveResponse> {
    return await this.channel.startUnary(request, this.getContext(), VoiceClient.isEventActiveMethodInfo, options);
  }
  private static readonly testMethodInfo: MethodInfo<IEmpty, IUser> = {
    name: 'test',
    service: 'VoiceService',
    id: 3275859992,
    serialize: Empty.encode,
    deserialize: User.decode,
    stringify: Empty.encodeToJSON,
    fromJSON: User.fromJSON,
    type: MethodType.Unary,
  }

  async test(request: IEmpty): Promise<IUser>;
  async test(request: IEmpty, options: CallOptions): Promise<IUser>;
  async test(request: IEmpty, options?: CallOptions): Promise<IUser> {
    return await this.channel.startUnary(request, this.getContext(), VoiceClient.testMethodInfo, options);
  }
}
